import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const SermorelinPage8: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  const options = ["Yes", "No"];

  useEffect(() => {
    const step7Completed = localStorage.getItem("completed-step-7");
      if (step7Completed) {
        navigate("/sermorelin/getting-started/step-8", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-7", { replace: true });
      }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem(
      "Do_you_have_untreated_hypothyroidism"
    );
    if (saved) {
      const parsed = JSON.parse(saved);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);

    localStorage.setItem(
      "Do_you_have_untreated_hypothyroidism",
      JSON.stringify({
        key: "Do_you_have_untreated_hypothyroidism",
        value: option,
      })
    );

    localStorage.setItem("completed-step-8", "true");
      if (option === "Yes") {
        setTimeout(() => {
        navigate("/sermorelin/disqualified");
      }, 1000);
      } else {
        setTimeout(() => {
        navigate("/sermorelin/getting-started/step-9");
      }, 1000);
      }
  };

  const handleBack = () => {
      navigate("/sermorelin/getting-started/step-7"); 
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={68} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
          Do you have untreated hypothyroidism?
          </p>
          <div className="options options-box">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SermorelinPage8;